import React from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox, Grid, Input } from 'semantic-ui-react';
import LibraryItemShow from './LibraryItemShow';
import { Dthc, MobileModal } from '../../../Modules';
import styles from '../../Proposal.scss';
import LibraryItemEditMobile from './LibraryItemEditMobile';
import LibraryItemEditDesktop from './LibraryItemEditDesktop';
import Formsy from 'formsy-react';

export default class LibraryMobile extends React.Component {
  static propTypes = {
    serviceChangeHandler: PropTypes.func.isRequired,
    updateService: PropTypes.func.isRequired,
    resetEditService: PropTypes.func.isRequired,
    deleteService: PropTypes.func.isRequired,
    serviceSelectHandler: PropTypes.func.isRequired,
    library: PropTypes.array.isRequired,
    localLibrary: PropTypes.array.isRequired,
    selectAll: PropTypes.func.isRequired,
    selectNone: PropTypes.func.isRequired,
    addSelected: PropTypes.func.isRequired,
    getTotalSelected: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    toggleMobileLibrary: PropTypes.func.isRequired,
    toggleMobileAdd: PropTypes.func.isRequired,
    toggleServiceSelect: PropTypes.func.isRequired,
    updateSearchQuery: PropTypes.func.isRequired,
    searchQuery: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.addSelected = this.addSelected.bind(this);
  }

  addSelected() {
    this.props.toggleMobileLibrary(false);
    this.props.addSelected();
  }

  render() {
    const { searchQuery } = this.props;
    return (
      <MobileModal
        open={this.props.open}
        onClose={this.props.toggleMobileLibrary.bind(null, false)}
        inline
      >
        <MobileModal.Header>
          <div className='menu'>
            <a className='item' onClick={this.props.toggleMobileLibrary.bind(null, false)}>
              Cancel
            </a>
          </div>
          <div className='right menu'>
            <a className='item' onClick={this.addSelected}>
              Add
            </a>
          </div>
        </MobileModal.Header>
        <div style={{ paddingTop: '5em', height: '100%', overflowY: 'scroll' }}>
          <div>
            <Grid container style={{ paddingBottom: '1em' }}>
              <Grid.Row>
                <Grid.Column width={10}>
                  <a onClick={this.props.selectAll}>Select All</a>{' '}
                  &nbsp;/&nbsp;&nbsp;
                  <a onClick={this.props.selectNone}>Deselect All</a>
                </Grid.Column>
                <Grid.Column textAlign='right' width={6}>
                  {this.props.getTotalSelected()} Selected
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Formsy.Form autoComplete='off'>
                    <Input
                      name='search'
                      type='text'
                      size='small'
                      icon='search'
                      placeholder='Filter...'
                      onChange={this.props.updateSearchQuery}
                      value={searchQuery}
                      fluid
                    />
                  </Formsy.Form>
                </Grid.Column>
              </Grid.Row>
              <br />
            </Grid>
            {this.props.library.length === 0 &&
              <div style={{ textAlign: 'center', padding: '2em' }}>
                <h4>You have no saved line items.</h4>
                <br />
                <Button
                  onClick={this.props.toggleMobileAdd.bind(null, true, true)}
                  primary
                  icon='plus'
                  labelPosition='left'
                  content='Add New Item'
                />
              </div>
            }
            {this.props.library.map((service, idx) =>
              <div key={service.node.id || idx}>
                <div
                  style={{ display: 'table-cell', padding: '1em 1.5em' }}
                  className={[
                    styles.libraryItem,
                    this.props.localLibrary[idx].checked ? styles.itemSelected : ''
                  ].join(' ')}
                  onClick={this.props.toggleServiceSelect.bind(null, idx)}
                >
                  <Checkbox
                    checked={this.props.localLibrary[idx].checked || false}
                    onChange={this.props.serviceSelectHandler.bind(
                      null,
                      idx
                    )}
                  />
                </div>
                <div style={{ display: 'table-cell', width: '100%' }}>
                  <Dthc
                    service={service.node}
                    localService={
                      this.props.localLibrary[idx].node
                    }
                    onChange={svc => {
                      this.props.serviceChangeHandler(svc, idx);
                    }}
                    commitUpdate={this.props.updateService}
                    desktop={LibraryItemEditDesktop}
                    mobile={LibraryItemEditMobile}
                    index={idx}
                    reset={this.props.resetEditService}
                    delete={this.props.deleteService}
                  >
                    <LibraryItemShow
                      service={service.node}
                      index={idx}
                    />
                  </Dthc>
                </div>
              </div>
            )}
          </div>
        </div>
      </MobileModal>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Library/LibraryMobile.js